<template>
  <aside class="messages__sidebar">
    <div class="messages__header">
      <h4 class="messages__title" v-if="hasAccessToFolder">
        <span v-if="folderId">
          Pliki znajdziesz w folderze o nazwie <code>{{ folderId }}</code>
        </span>
        <span v-else> Brak folderu z załącznikami dla tego zgłoszenia </span>
      </h4>
    </div>

    <div class="messages__sidebar-content" v-if="folderId">
      <h4>Dodaj załączniki do wiadomości:</h4>
      <p>Pliki zostaną załączone do folderu zgłoszenia <strong>po wysłaniu wiadomości</strong>.</p>
      <Droparea direction="column" :folder-id="folderId" :key="key" @updateStatus="onUpdateStatus" />
    </div>
  </aside>
</template>

<script>
import Droparea from '@/components/ui/Droparea.vue';

export default {
  name: "ThreadAttachments",
  components: {
    Droparea,
  },
  props: {
    folderId: {
      type: String,
      required: true,
    },
    hasAccessToFolder: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      attachmentsStatus: null,
      key: 0,
    };
  },
  methods: {
    uploadInProgress() {
      return this.attachmentsStatus !== "" && this.attachmentsStatus !== "completed";
    },
    onUpdateStatus(status) {
      this.attachmentsStatus = status;
      if (status === "completed") this.key++;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.uploadInProgress()) {
      if (!window.confirm("Przesyłanie plików nie zostało zakończone. Na pewno chcesz opuścić tę stronę?")) {
        return;
      }
    }
    next();
  },
};
</script>